import styled, { css } from 'styled-components';
import { colors } from '@/styles';
import * as TabsPrimitive from '@radix-ui/react-tabs';

const pillStyles = (props: { $small?: boolean; $open?: boolean }) => {
  return {
    list: css`
      position: relative;
      display: flex;
      gap: 5px;
      align-items: center;
      padding: 5px;

      background: ${colors.secondary.lightGray2};
      border: 1px solid ${colors.secondary.lightGray3};
      border-radius: ${props.$open ? '5px' : '5px 5px 0 0'};
      border-bottom: ${!props.$open && 'none'};
    `,
    trigger: css`
      font-weight: 500;
      border: 1px solid transparent;
      background: transparent;
      border-width: 1px;
      border-radius: 5px;
      border-style: solid;
      padding: ${props.$small ? '5px 10px' : '8px 20px'};
      color: ${colors.secondary.darkGray1};
      cursor: pointer;

      .count-tag {
        background: ${colors.primary.white};
        margin-left: 5px;
      }

      &[aria-selected='true'] {
        font-weight: bold;
        color: ${colors.secondary.darkGray1};
        border-color: ${colors.secondary.lightGray3};
        background: ${colors.primary.white};
        .count-tag {
          background: ${colors.secondary.lightGray2};
        }
      }
    `,
    content: css`
      padding: ${props.$open ? '20px 0' : '20px'};
      border: 1px solid ${props.$open ? 'transparent' : colors.secondary.lightGray3};
      border-radius: 0 0 5px 5px;
      background: ${props.$open ? 'transparent' : colors.secondary.lightGray1};
      /* padding-top: 20px; */
    `,
  };
};

export const List = styled(TabsPrimitive.List)<{ $small?: boolean; $open?: boolean }>`
  ${({ $small, $open }) => pillStyles({ $small, $open }).list}
`;

export const Trigger = styled(TabsPrimitive.Trigger)<{ $small?: boolean; $open?: boolean }>`
  ${({ $small, $open }) => pillStyles({ $small, $open }).trigger}
`;

export const Content = styled(TabsPrimitive.Content)<{ $small?: boolean; $open?: boolean }>`
  ${({ $small, $open }) => pillStyles({ $small, $open }).content}
`;
